import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOPS_M1_SpecificationOfTokensExtendedRE = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Specification of Tokens-Extended Regular Expression"
    videos={[
      "https://www.youtube.com/embed/e-WJJl1Wzc4",
    ]}
    takeaways={[
      { text: "The most common question from this topic is construct regular expression for an identifier in C or C++ language" },
      { text: "Application based question can be asked on this topic" },
    ]}
    questions={[
      "Write regular definitions for identifiers in C language. The C identifiers are usually strings of letters, digits, and underscores.",
      'Write a regular expression for a language containing strings that end with "abb" over Σ={a,b}.',
      "Write regular expressions to describe a language consist of strings made of even numbers a and b",
      "Write regular definitions for identifiers in C language. Assume a valid identifier must follow the given below set of rules. . An identifier can include letters (a-z or A-Z), and digits (0-9). . An identifier cannot include special characters except the '_' underscore. . Spaces are not allowed while naming an identifier. . An identifier can only begin with an underscore or letters.",
    ]}
    exampleVideos={[]}
  />
);
}

export default OOPS_M1_SpecificationOfTokensExtendedRE;
